import classNames from 'classnames';
var FormRow = function (_a) {
    var children = _a.children, className = _a.className;
    return (<div className={classNames('flex w-full flex-col gap-4 md:flex-row', className)}>
      {children}
    </div>);
};
export default FormRow;
